const e = {
  blur: {
    glass: {
      100: "15px"
    }
  },
  border: {
    radius: {
      small: "8px",
      default: "16px",
      large: "24px",
      button: {
        default: "8px",
        pill: "32px"
      },
      badge: {
        default: "4px"
      }
    }
  },
  breakpoints: {
    "mobile-portrait-small": "320px",
    "mobile-portrait": "375px",
    "mobile-landscape": "500px",
    "tablet-portrait": "768px",
    "tablet-landscape": "1024px",
    desktop: "1200px",
    "desktop-wide": "1440px"
  },
  color: {
    white: "#ffffff",
    black: "#000000",
    neutral: {
      100: "#ffffff",
      200: "#fafafa",
      300: "#e8e8e8",
      400: "#595959",
      500: "#3d3d3d",
      600: "#000000"
    },
    "interface-blue": {
      100: "#e0e8eb",
      200: "#c1d1d7",
      300: "#a2bbc3",
      400: "#648d9b",
      500: "#50717c",
      600: "#28393e"
    },
    "interactive-blue": {
      100: "#6bbfff",
      200: "#38a9ff",
      300: "#0077d1",
      400: "#005a9e",
      500: "#003d6b"
    },
    platform: {
      white: "#ffffff",
      black: "#000000",
      neutral: {
        100: "#fafafa",
        200: "#f0f0f0",
        300: "#d6d6d6",
        400: "#bdbdbd",
        500: "#a3a3a3",
        600: "#8a8a8a",
        700: "#707070",
        800: "#575757",
        900: "#3d3d3d",
        1e3: "#242424",
        1100: "#0a0a0a"
      },
      interface: {
        100: "#f9fafb",
        200: "#f0f4f5",
        300: "#e0e8eb",
        400: "#c1d1d7",
        500: "#a2bbc3",
        600: "#83a4af",
        700: "#648d9b",
        800: "#50717c",
        900: "#3c555d",
        1e3: "#28393e",
        1100: "#141c1f"
      },
      interactive: {
        100: "#f0f9ff",
        200: "#dbf0ff",
        300: "#d1ebff",
        400: "#9ed5ff",
        500: "#6bbfff",
        600: "#38a9ff",
        700: "#0593ff",
        800: "#0077d1",
        850: "#0069b8",
        900: "#005a9e",
        1e3: "#003d6b",
        1100: "#002038"
      }
    },
    science: {
      primary: {
        100: "#cefbcb",
        200: "#74f36d",
        300: "#1ee713",
        400: "#18b80f",
        500: "#12880b",
        600: "#0c5907"
      },
      secondary: {
        100: "#94f0df",
        200: "#2eb7bf",
        300: "#037fc5"
      },
      gradient: {
        1: "#000000",
        2: "#000000",
        3: "#000000"
      }
    },
    health: {
      primary: {
        100: "#e1b7cf",
        200: "#d194b6",
        300: "#c2709e",
        400: "#b34c86",
        500: "#8f3d6b",
        600: "#6b2e50"
      },
      secondary: {
        100: "#eafc83",
        200: "#ceee07",
        300: "#a2bd05"
      }
    },
    "social-studies": {
      primary: {
        100: "#ffe2d1",
        200: "#ffc19e",
        300: "#ffa06b",
        400: "#ff8038",
        500: "#ff5f05",
        600: "#9e3900"
      },
      secondary: {
        100: "#eafc83",
        200: "#ceee07",
        300: "#a2bd05"
      },
      gradient: {
        1: "#000000",
        2: "#000000",
        3: "#000000"
      }
    },
    math: {
      primary: {
        100: "#c0a4f4",
        200: "#a077ee",
        300: "#814ae8",
        400: "#611de2",
        500: "#4e17b5",
        600: "#270b5a"
      },
      secondary: {
        100: "#f82289",
        200: "#fa5ca8",
        300: "#fca6cf"
      },
      gradient: {
        1: "#000000",
        2: "#000000",
        3: "#000000"
      }
    },
    teach: {
      primary: {
        100: "#fffae0",
        200: "#fff2ad",
        300: "#ffea7a",
        400: "#ffe247",
        500: "#ffda15",
        600: "#ad9200"
      },
      secondary: {
        100: "#89a3ff",
        200: "#577cfe",
        300: "#4830dd"
      }
    },
    coding: {
      primary: {
        100: "#a1cff7",
        200: "#72b7f3",
        300: "#439fef",
        400: "#1487eb",
        500: "#106cbc",
        600: "#0c518d"
      },
      secondary: {
        100: "#10c1d8",
        200: "#1170c3",
        300: "#972ee3"
      }
    },
    stem: {
      primary: {
        100: "#b1e7dd",
        200: "#89dccd",
        300: "#62d0bc",
        400: "#3bc4ab",
        500: "#2f9d89",
        600: "#174f45"
      },
      secondary: {
        100: "#ffe926",
        200: "#d6c31d",
        300: "#ac9d15"
      }
    },
    feedback: {
      success: {
        50: "#e8fcec",
        100: "#d2f9d8",
        200: "#a5f3b2",
        300: "#78ed8b",
        400: "#4be764",
        500: "#1ee13e",
        600: "#18b431",
        700: "#128725",
        800: "#0c5a19",
        900: "#062d0c",
        1e3: "#031706"
      },
      error: {
        50: "#fce8e8",
        100: "#f9d2d2",
        200: "#f3a5a5",
        300: "#ed7878",
        400: "#e74b4b",
        500: "#e11e1e",
        600: "#b41818",
        700: "#871212",
        800: "#5a0c0c",
        900: "#2d0606",
        1e3: "#170303"
      },
      warning: {
        50: "#fff3e5",
        100: "#ffe8cc",
        200: "#ffd099",
        300: "#ffb966",
        400: "#ffa133",
        500: "#ff8a00",
        600: "#cc6e00",
        700: "#995300",
        800: "#663700",
        900: "#331c00",
        1e3: "#1a0e00"
      }
    },
    highlight: {
      pastel: {
        yellow: "#fffc8f",
        blush: "#ffaedf",
        peach: "#ffc9ad",
        mint: "#adffad",
        turquoise: "#adebff",
        lavendar: "#dbadff"
      },
      vibrant: {
        yellow: "#fffa5c",
        blush: "#ff5cbe",
        peach: "#ff935c",
        mint: "#5cff5c",
        turquoise: "#5cd7ff",
        lavendar: "#b75cff"
      }
    },
    error: "#e32b2b",
    warning: "#db7600",
    success: "#128725",
    glass: {
      100: "rgba(#50717c, .75)"
    }
  },
  dim: {
    scale: "8px",
    quarter: "2px",
    half: "4px",
    "1x": "8px",
    "2x": "16px",
    "3x": "24px",
    "4x": "32px",
    "5x": "40px",
    "6x": "48px",
    "7x": "56px",
    "8x": "64px",
    "9x": "72px",
    "10x": "80px"
  },
  gradient: {
    "science-1": "linear-gradient(53.49deg, #2EE916 22.68%, #00C000 88.08%)",
    "science-2": "linear-gradient(240.47deg, #2EB7BF 12.66%, #7ADF07 115.1%)",
    "science-3": "linear-gradient(247.05deg, #2EBFA5 16.79%, #037FC5 101.74%)",
    "math-1": "linear-gradient(53.49deg, #4E17B5 22.68%, #7E00CC 71.96%)",
    "math-2": "linear-gradient(240.47deg, #F82289 12.66%, #7E00CC 115.1%)",
    "math-3": "linear-gradient(235deg, #FCA6CF 12.36%, #F82289 115.93%)",
    "social-studies-1": "linear-gradient(53.49deg, #FF5E03 22.68%, #CB4814 88.08%)",
    "social-studies-2": "linear-gradient(233deg, #CEEE07 -1.34%, #FF5E03 98.48%)",
    "social-studies-3": "linear-gradient(238deg, #CEEE07 0.41%, #A2BD05 77.83%)"
  },
  font: {
    family: {
      display: [
        "'Proxima Vara'",
        "Arial",
        "sans-serif"
      ],
      body: [
        "'Proxima Vara'",
        "Arial",
        "sans-serif"
      ],
      header: [
        "'Proxima Vara'",
        "Arial",
        "sans-serif"
      ],
      serif: [
        "'Droid Serif'",
        "Georgia",
        "serif"
      ],
      mystery: [
        "Agrandir",
        "sans-serif"
      ]
    },
    size: {
      "rem-base": "16px",
      "body-1": "1.125rem",
      "body-2": "1rem",
      header: {
        "level-1": "4.25rem",
        "level-2": "3.375rem",
        "level-3": "2.6875rem",
        "level-4": "2.1875rem",
        "level-5": "1.75rem",
        "level-6": "1.5rem"
      },
      caption: ".875rem",
      jumbo: "5.3125rem",
      card: {
        title: "1.25rem"
      },
      mobile: {
        "body 1": "1rem",
        header: {
          "level-1": "2rem",
          "level-2": "1.75rem",
          "level-3": "1.625rem",
          "level-4": "1.5rem",
          "level-5": "1.375rem",
          "level-6": "1.25rem"
        }
      }
    },
    "line-height": {
      default: "1.4",
      heading: "1.2"
    },
    weight: {
      body: "normal",
      header: "bold"
    }
  },
  icon: {
    size: {
      s: "16px",
      m: "24px",
      l: "32px",
      xl: "40px",
      xxl: "48px"
    }
  },
  overlay: {
    default: ".65",
    dark: ".85"
  },
  shadow: {
    100: "0px 2px 6px rgba(0, 0, 0, 0.15)",
    200: "0px 2px 10px 2px rgba(0, 0, 0, 0.1)",
    300: "0px 4px 15px 2px rgba(0, 0, 0, 0.1)",
    400: "0px 4px 26px 5px rgba(0, 0, 0, 0.1)"
  },
  space: {
    scale: "8px",
    quarter: "2px",
    half: "4px",
    "1x": "8px",
    "2x": "16px",
    "3x": "24px",
    "4x": "32px",
    "5x": "40px",
    "6x": "48px",
    "7x": "56px",
    "8x": "64px",
    "9x": "72px",
    "10x": "80px"
  },
  "text-color": {
    body: {
      default: "#575757",
      "on-dark": "#ffffff"
    },
    header: {
      default: "#3d3d3d",
      "on-dark": "#ffffff"
    },
    link: {
      default: "#0077d1",
      active: "#005a9e",
      hover: "#003d6b",
      "on-dark": "#ffffff"
    }
  },
  "text-decoration": {
    link: "underline"
  },
  transition: {
    default: ".25s ease-in-out",
    "fade-in": ".25s ease-in",
    "fade-out": ".45s ease-out"
  }
}, a = {
  tokens: e
};
export {
  a as n
};
